import erc20AbiJson from "./abis/ERC200.json";
import stakingRewardsAbiJson from "./abis/stakingRewards.json";

// Type helper for addresses (optional but good practice)
type ContractAddresses = {
  [key: string]: `0x${string}`; // Enforce 0x prefix string format
};

export const ADDRESSES: ContractAddresses = {
  NAU: "0x1A7F059f6Bc234D1D03075B430e26c67856B53dE",
  NAUY: "0x8fE351FD35DDC08bc2f3c5fA573B44d6E13f97ec",
  NAUN: "0x885f14Ec5c427767A660174ea0EA8C9953f3549D",
  NAU_STAKING: "0x399095b87f77eDD8d811cB69B51db81ca889d315",
  NAUY_STAKING: "0xDb51A363bf304e9A0ef66C29496AE5F8F3ABeDA4",
  NAUN_STAKING: "0xA2baEcb35ec71EE702Da05a73c8F3F5C4b44F77D",
};

// Export ABIs (asserting type as const for better type inference with wagmi)
export const erc20Abi = erc20AbiJson;
export const stakingRewardsAbi = stakingRewardsAbiJson;

// Helper type for token symbols
export type TokenSymbol = "NAU" | "NAUY" | "NAUN";
export const VALID_SYMBOLS: TokenSymbol[] = ["NAU", "NAUY", "NAUN"];

// Block Explorer URL for Base Mainnet (adjust if using testnet later)
export const BLOCK_EXPLORER_URL = "https://basescan.org";
